// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-method-tabs {
  display: flex;
  margin-bottom: 20px;
  background-color: #f4f5f7;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.login-tab {
  min-width: 193px;
  height: 50px !important;
  flex: 1 1;
  text-align: center;
  padding: 12px 50px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  font-size: 16px;
  color: #0a0a0a;
}

.login-tab.active {
  background-color: #564ffd;
  color: #ffffff;
  box-shadow: inset 0 -4px 0 rgba(255, 255, 255, 0.2);
}

.login-tab:hover {
  background-color: #7265e6;
  color: #ffffff;
}

.login-btn {
  min-width: 193px;
  height: 42px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  background-color: #564ffd !important;
  gap: 20px;
}

.forgot-password-link {
  margin-top: 10px;
  text-decoration: none;
  cursor: pointer;
  color: #564ffd !important;
}

.input-group-text {
  height: 42px !important;
}

.form-control {
  height: 42px !important;
  font-size: 16px !important;
  border: 1px solid #e9eaf0 !important;
  border-radius: 0 !important;
}

/* Ensure error messages don't push content */
.text-danger {
  margin: 0;
  padding-top: 4px; /* Add space above the error message */
  font-size: 12px; /* Reduce font size if necessary */
  height: 18px; /* Set a fixed height to reserve space */
}`, "",{"version":3,"sources":["webpack://./src/components/Auth/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,uDAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,mDAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,8BAAA;EACA,oCAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;AACF;;AAEA,6CAAA;AACA;EACE,SAAA;EACA,gBAAA,EAAA,sCAAA;EACA,eAAA,EAAA,kCAAA;EACA,YAAA,EAAA,wCAAA;AACF","sourcesContent":[".login-method-tabs {\n  display: flex;\n  margin-bottom: 20px;\n  background-color: #f4f5f7;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.login-tab {\n  min-width: 193px;\n  height: 50px !important;\n  flex: 1;\n  text-align: center;\n  padding: 12px 50px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  font-size: 16px;\n  color: #0a0a0a;\n}\n\n.login-tab.active {\n  background-color: #564ffd;\n  color: #ffffff;\n  box-shadow: inset 0 -4px 0 rgba(255, 255, 255, 0.2);\n}\n\n.login-tab:hover {\n  background-color: #7265e6;\n  color: #ffffff;\n}\n\n.login-btn {\n  min-width: 193px;\n  height: 42px !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  background-color: #564ffd !important;\n  gap: 20px;\n}\n\n.forgot-password-link {\n  margin-top: 10px;\n  text-decoration: none;\n  cursor: pointer;\n  color: #564ffd !important;\n}\n\n.input-group-text {\n  height: 42px !important;\n}\n\n.form-control {\n  height: 42px !important;\n  font-size: 16px !important;\n  border: 1px solid #e9eaf0 !important;\n  border-radius: 0 !important;\n}\n\n/* Ensure error messages don't push content */\n.text-danger {\n  margin: 0;\n  padding-top: 4px; /* Add space above the error message */\n  font-size: 12px; /* Reduce font size if necessary */\n  height: 18px; /* Set a fixed height to reserve space */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
